/** Brand marks for integration cards (inline SVG — no extra assets). */
export default function IntegrationIcon({ logo, fallback, className = "" }) {
  const common = { className, viewBox: "0 0 24 24", role: "img", "aria-hidden": true };

  switch (logo) {
    case "whatsapp":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="12" fill="#25D366" />
          <path
            fill="#fff"
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
          />
          <path
            fill="#fff"
            d="M12.004 3.2c-4.85 0-8.804 3.954-8.804 8.804 0 1.55.405 3.07 1.175 4.41L3.2 20.8l4.52-1.14a8.77 8.77 0 0 0 4.284 1.1h.004c4.85 0 8.804-3.954 8.804-8.804 0-2.35-.916-4.56-2.58-6.22a8.75 8.75 0 0 0-6.228-2.576zm0 15.96h-.003a7.3 7.3 0 0 1-3.72-1.02l-.266-.158-2.68.678.715-2.61-.174-.268a7.28 7.28 0 0 1-1.12-3.88c0-4.03 3.28-7.31 7.31-7.31 1.954 0 3.79.762 5.17 2.144a7.27 7.27 0 0 1 2.148 5.174c0 4.03-3.28 7.31-7.31 7.31z"
          />
        </svg>
      );
    case "google-meet":
      return (
        <svg {...common}>
          <path fill="#00832D" d="M6 5h7.5L18 9.5V19H6z" />
          <path fill="#2684FC" d="M13.5 5v4.5H18z" />
          <path fill="#EA4335" d="M13.5 9.5H18L13.5 5z" />
          <path fill="#00AC47" d="M6 5v14h7.5V5z" opacity="0.9" />
          <path fill="#fff" d="M9.2 11.2l4.8 2.8v-5.6z" />
          <path fill="#FFBA00" d="M18 9.5V19l3-2.5V12z" />
        </svg>
      );
    case "google-drive":
      return (
        <svg {...common}>
          <path fill="#3777E3" d="M8.1 20 3 11.5 8.1 3h7.8L21 11.5 15.9 20z" />
          <path fill="#FFCF63" d="M3 11.5h10.05L8.1 20 3 11.5z" />
          <path fill="#11A861" d="M13.05 11.5H21L15.9 20H8.1l4.95-8.5z" />
        </svg>
      );
    case "google-calendar":
      return (
        <svg {...common}>
          <rect x="3" y="5" width="18" height="16" rx="2" fill="#fff" stroke="#4285F4" strokeWidth="1.5" />
          <path fill="#4285F4" d="M3 9h18V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2z" />
          <text x="12" y="17" textAnchor="middle" fill="#4285F4" fontSize="7" fontWeight="700" fontFamily="sans-serif">
            31
          </text>
        </svg>
      );
    case "google-docs":
      return (
        <svg {...common}>
          <path fill="#4285F4" d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          <path fill="#A1C2FA" d="M14 3v5h5" />
          <path fill="#fff" d="M8.5 12h7v1.2h-7zm0 2.8h7v1.2h-7zm0 2.8h5v1.2h-5z" />
        </svg>
      );
    case "api":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" fill="rgba(139,107,255,0.2)" stroke="rgba(139,107,255,0.6)" strokeWidth="1.5" />
          <path fill="none" stroke="#8b6bff" strokeWidth="1.5" d="M8 12h8M12 8v8" />
        </svg>
      );
    default:
      return <span className={className}>{fallback || "🔗"}</span>;
  }
}
